const { LISTING_PAGES } = require('./constants');

const getTotalListingPages = ({ isTouch, isMobile }) =>
    !isMobile && !isTouch ? LISTING_PAGES.EXTENDED : LISTING_PAGES.DEFAULT;

module.exports = { getTotalListingPages };
